import { useRef } from "react";

export function useDragScroll(scrollContainerRef: React.RefObject<HTMLDivElement | null>) {
  const isDraggingRef = useRef(false);
  const dragStartXRef = useRef(0);
  const scrollStartXRef = useRef(0);

  const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!scrollContainerRef.current) return;
    isDraggingRef.current = true;
    dragStartXRef.current = e.clientX;
    scrollStartXRef.current = scrollContainerRef.current.scrollLeft;
    scrollContainerRef.current.style.cursor = "grabbing";
  };

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!isDraggingRef.current || !scrollContainerRef.current) return;
    e.preventDefault();
    const deltaX = e.clientX - dragStartXRef.current;
    scrollContainerRef.current.scrollLeft = scrollStartXRef.current - deltaX;
  };

  const endDrag = () => {
    if (!scrollContainerRef.current) return;
    isDraggingRef.current = false;
    scrollContainerRef.current.style.cursor = "grab";
  };

  return {
    handleMouseDown,
    handleMouseMove,
    handleMouseLeave: endDrag,
    handleMouseUp: endDrag,
  };
}
